import classNames from 'classnames'
import React from 'react'

import { FieldControlProps } from 'shared-libs/components/ui2/fields/field-ui/field-control/field-control-props'
import { useFieldShellContext } from 'shared-libs/components/ui2/fields/field-ui/field-shell/field-shell-context'
import './_field-control.scss'

export interface IUI2FieldControlProps extends FieldControlProps {
  className?: string
  children: React.ReactNode
}

export const UI2FieldControl: React.FC<IUI2FieldControlProps> = ({
  leftAddon,
  rightAddon,
  leftContent,
  rightContent,
  footer,
  className,
  children,
}) => {
  const { isDisabled, hasError, prefilledCancelNode, footerContent } = useFieldShellContext()
  const bodyRef = React.useRef<HTMLDivElement>(null)
  const effectiveFooter = footer ?? footerContent

  const handleBodyMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target !== e.currentTarget) return
    const focusable = bodyRef.current?.querySelector<HTMLElement>(
      'input, textarea, select, [tabindex]:not([tabindex="-1"])'
    )
    if (focusable) {
      e.preventDefault()
      focusable.focus()
    }
  }

  return (
    <div
      className={classNames('ui2-fieldControl', className, {
        'ui2-fieldControl--disabled': isDisabled,
        'ui2-fieldControl--error': hasError,
      })}
    >
      <div className='ui2-fieldControl-row'>
        {leftAddon && <div className='ui2-fieldControl-leftAddon'>{leftAddon}</div>}
        <div className='ui2-fieldControl-body' ref={bodyRef} onMouseDown={handleBodyMouseDown}>
          {leftContent && (
            <div className='ui2-fieldControl-leftContent'>{leftContent}</div>
          )}
          {children}
          {rightContent && (
            <div className='ui2-fieldControl-rightContent'>{rightContent}</div>
          )}
        </div>
        {rightAddon && <div className='ui2-fieldControl-rightAddon'>{rightAddon}</div>}
        {prefilledCancelNode && (
          <div className='ui2-fieldControl-cancelSlot'>{prefilledCancelNode}</div>
        )}
      </div>
      {effectiveFooter && <div className='ui2-fieldControl-footer'>{effectiveFooter}</div>}
    </div>
  )
}
